import ahsanSajidImage from "@/assets/ahsan-sajid.png";

export const SecureCodingFounderQuote = () => {
  return (
    <div className="bg-card rounded-2xl border border-border p-6 sm:p-8">
      <div className="flex items-start gap-4">
        <img
          src={ahsanSajidImage}
          alt="Ahsan Sajid"
          className="w-14 h-14 rounded-full object-cover border-2 border-primary/20"
        />
        <div>
          <blockquote className="text-foreground italic leading-relaxed">
            "Security isn't a feature — it's a reputation. One breach can undo years of trust. That's why 
            learning secure coding from day one matters. Do code reviews with security in mind, and never 
            rush a release that hasn't passed security checks. It's non-negotiable in professional software 
            development."
          </blockquote>
          <div className="mt-4">
            <p className="font-semibold text-foreground">Ahsan Sajid</p>
            <p className="text-sm text-muted-foreground">Owner, IT Dukes</p>
          </div>
        </div>
      </div>
    </div>
  );
};
